/* Meta Pixel events for forms the channel app does not cover.
   Fires Subscribe on newsletter form (1-field email).
   Fires Contact on full contact form (name + email + body).
   Channel app already handles PageView, ViewContent, AddToCart,
   InitiateCheckout, AddPaymentInfo, Purchase, Search. */

(function () {
  function fire(eventName) {
    if (typeof window.fbq !== 'function') return;
    window.fbq('track', eventName);
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || form.tagName !== 'FORM') return;
    var action = (form.getAttribute('action') || form.action || '');
    if (action.indexOf('/contact') === -1) return;

    var hasName = !!form.querySelector('[name="contact[name]"]');
    var hasBody = !!form.querySelector('[name="contact[body]"]');
    var hasEmail = !!form.querySelector('[name="contact[email]"]');

    if (hasEmail && hasName && hasBody) {
      fire('Contact');
    } else if (hasEmail) {
      fire('Subscribe');
    }
  }, true);
})();
